import React, { useEffect, useState } from "react";
import { Model } from "../../models/model";
import { Buttons } from "../reusableUI/Buttons";
import { Link } from "react-router-dom";
import { DialogAssignedUsers } from "../ajustes/asignar_email_reportes/DialogAssignedUsers";

const periodicidad = [
  { id: "diario", nombre: "diario" },
  { id: "1", nombre: "Lunes" },
  { id: "2", nombre: "Martes" },
  { id: "3", nombre: "Miercoles" },
  { id: "4", nombre: "Jueves" },
  { id: "5", nombre: "Viernes" },
  { id: "6", nombre: "Sábado" },
  { id: "7", nombre: "Domingo" },
];

const times = [
  { id: "0", nombre: "12:00am" },
  { id: "1", nombre: "1:00am" },
  { id: "2", nombre: "2:00am" },
  { id: "3", nombre: "3:00am" },
  { id: "4", nombre: "4:00am" },
  { id: "5", nombre: "5:00am" },
  { id: "6", nombre: "6:00am" },
  { id: "7", nombre: "7:00am" },
  { id: "8", nombre: "8:00am" },
  { id: "9", nombre: "9:00am" },
  { id: "10", nombre: "10:00am" },
  { id: "11", nombre: "11:00am" },
  { id: "12", nombre: "12:00pm" },
  { id: "13", nombre: "1:00pm" },
  { id: "14", nombre: "2:00pm" },
  { id: "15", nombre: "3:00pm" },
  { id: "16", nombre: "4:00pm" },
  { id: "17", nombre: "5:00pm" },
  { id: "18", nombre: "6:00pm" },
  { id: "19", nombre: "7:00pm" },
  { id: "20", nombre: "8:00pm" },
  { id: "21", nombre: "9:00pm" },
  { id: "22", nombre: "10:00pm" },
  { id: "23", nombre: "11:00pm" },
];

export const EmailReportes = () => {
  const [reports, setReports] = useState([]);
  const [reportsIni, setReportsIni] = useState([]);
  const [openAsignar, setOpenAsignar] = useState(false);
  const [emailSelected, setEmailSelected] = useState({});

  useEffect(() => {
    getAllEmailReportes();
  }, []);

  const getAllEmailReportes = async () => {
    const results = await Model.getAll({
      url: "ajustes/email-reportes",
    });

    setReports(results || []);
    setReportsIni(results || []);
  };

  const handleHabilitado = (e, id) => {
    const newStatus = e.target.checked;

    const listUpdated = reports.map((it) => {
      if (it.id === id) {
        return {
          ...it,
          habilitado: newStatus,
        };
      }

      return it;
    });

    setReports(listUpdated);
  };

  const handleChange = (e, id) => {
    const newValue = e.target.value;

    const listUpdated = reports.map((it) => {
      if (it.id === id) {
        return {
          ...it,
          [e.target.name]: newValue,
        };
      }

      return it;
    });

    setReports(listUpdated);
  };

  const handleOpenAsignar = (InfoEmail) => {
    setEmailSelected(InfoEmail);
    setOpenAsignar(true);
  };

  const handleSave = async () => {
    await Model.update({
      url: "ajustes/email-reportes/0",
      dataForm: {
        reports,
      },
    });

    setReportsIni(reports);
  };

  const handleSend = async (id) => {
    await Model.save({
      url: "email-reports/send",
      dataForm: {
        report_id: id,
      },
    });
  };

  const handleHabilitadoUsers = (reportId, newUsersList) => {
    const listUpdated = reports.map((it) => {
      if (it.id === reportId) {
        return {
          ...it,
          users: newUsersList,
        };
      }

      return it;
    });

    setReports(listUpdated);
  };

  return (
    <div className="container">
      <div className="row p-contet-title-info-personal">
        <div className="col-12">
          <h3 className="text-start p-title-info-personal">
            Ajustes de reportes programables vía email
          </h3>
        </div>
        <div className="col-12 p-text-info-personal">
          <h6>Envío de reportes de acuerdo a programación</h6>
        </div>
      </div>

      <div className="mt-4">
        <table className="table">
          <thead>
            <tr>
              <th className="text-center">Habilitado</th>
              <th className="text-start">Email reporte</th>
              <th className="text-center">Módulo</th>
              <th className="text-center">Periodicidad</th>
              <th className="text-center">Hora envío</th>
              <th className="text-start" colSpan={2}>
                Usuarios asignados
              </th>
            </tr>
          </thead>
          <tbody>
            {reports.map((it) => (
              <tr style={{ fontSize: "14px", textTransform: "capitalize" }}>
                <td className="text-center">
                  <input
                    type="checkbox"
                    checked={it?.habilitado || false}
                    style={{ height: "17px", width: "17px", cursor: "pointer" }}
                    onChange={(e) => handleHabilitado(e, it.id)}
                  />
                </td>
                <td className="text-start">
                  <span>{it?.nombre || "---"}</span>
                  <span className="ms-2">
                    <button
                      className="border text-[10px] p-1 rounded-md hover:underline"
                      onClick={() => handleSend(it.id)}
                    >
                      Enviar
                    </button>
                  </span>
                </td>
                <td className="text-center">{it?.modulo || "---"}</td>
                <td className="text-center">
                  <select
                    name="envio_periodicidad"
                    style={{ border: "none", textAlign: "center" }}
                    onChange={(e) => handleChange(e, it.id)}
                  >
                    <option key="" value="">
                      --seleccionar--
                    </option>
                    {periodicidad.map((pe) => {
                      if (pe.id === it?.envio_periodicidad) {
                        return (
                          <option key={pe.id} value={pe.id} selected>
                            {pe.nombre}
                          </option>
                        );
                      } else {
                        return (
                          <option key={pe.id} value={pe.id}>
                            {pe.nombre}
                          </option>
                        );
                      }
                    })}
                  </select>
                </td>
                <td className="text-center">
                  <select
                    name="envio_hora"
                    style={{ border: "none", textAlign: "center" }}
                    onChange={(e) => handleChange(e, it.id)}
                  >
                    <option key="" value="">
                      --seleccionar--
                    </option>
                    {times.map((ho) => {
                      if (ho.id === it?.envio_hora) {
                        return (
                          <option key={ho.id} value={ho.id} selected>
                            {ho.nombre}
                          </option>
                        );
                      } else {
                        return (
                          <option key={ho.id} value={ho.id}>
                            {ho.nombre}
                          </option>
                        );
                      }
                    })}
                  </select>
                </td>
                <td className="text-center">
                  {it?.users
                    .filter((act) => act.habilitado)
                    .map((user) => (
                      <span
                        key={user.id}
                        style={{
                          border: "1px solid gray",
                          borderRadius: "4px",
                          marginRight: "5px",
                          fontSize: "11px",
                          padding: "2px",
                        }}
                      >
                        {user.nombre}
                      </span>
                    ))}

                  {(it?.users.filter((act) => act.habilitado)).length === 0 ? (
                    <span>Ninguno</span>
                  ) : (
                    ""
                  )}
                </td>
                <td className="text-center">
                  {it.habilitado ? (
                    <Link to="" onClick={() => handleOpenAsignar(it)}>
                      Asignar
                    </Link>
                  ) : (
                    ""
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {JSON.stringify(reports) !== JSON.stringify(reportsIni) ? (
        <div className="mt-5">
          <Buttons label="Guardar cambios" type="button" onClick={handleSave} />
        </div>
      ) : (
        ""
      )}

      {openAsignar && (
        <DialogAssignedUsers
          open={openAsignar}
          setOpen={setOpenAsignar}
          infoEmail={emailSelected}
          handleHabilitadoUsers={handleHabilitadoUsers}
        />
      )}
    </div>
  );
};
